import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardDatabaseConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:database';

  override async prepareBlock(
    snapshot: BlockSnapshot
  ): Promise<PreparedEdgelessBlock | null> {
    const oldId = snapshot.id;

    delete snapshot.props.index;
    if (!snapshot.props.xywh) {
      console.error(`Database block(id: ${oldId}) does not have xywh property`);
      return null;
    }

    const prepared = await this.prepareSnapshotPaste(
      snapshot,
      this.std.store,
      this.std.store.root!.id
    );
    if (!prepared)
      console.error(`Failed to paste database block(id: ${oldId})`);
    return prepared;
  }
}
